<template>
    <!-- <h2>Footer</h2> -->
    <div id="cont" class="footer">
        <div class="__top"></div>
        <div class="__bottom"></div>
        
        <div class="__info container">
            <div class="__title">
                Остались вопросы?
            </div>
            <div class="__content">
                <div class="__form">
                    <slot></slot>
                </div>
                <div class="__contacts">
                    <div class="__notes">
                        или напишите нам
                    </div>
                    <!-- <div class="__buttons">
                        <button @click="()=>{ handleClickButton(contacts.tel.href) }">{{ contacts.tel.title }}</button>
                        <button>TG</button>
                        <button>WA</button>
                    </div> -->
                    <div class="__links">
                        <a :href="contacts.email.href">{{ contacts.email.title }}</a>
                        <a :href="contacts.telegram.href"><div><img :src="tg" alt="telegram">{{ contacts.telegram.title }}</div></a>
                        <a :href="contacts.whatsapp.href"><div><img :src="wa" alt="whatsapp">{{ contacts.whatsapp.title }}</div></a>
                    </div>
                </div>
            </div>
        </div>
        <div class="__end">
            <div id="cont" class="__contacts">
                <!-- Контакты: -->
                <a :href="contacts.tel.href">{{ contacts.tel.title }}</a>
                <a :href="contacts.telegram.href"><div><img :src="tg" alt="telergam">{{ contacts.telegram.title }}</div></a>
                <a :href="contacts.whatsapp.href"><div><img :src="wa" alt="whatsapp">{{ contacts.whatsapp.title }}</div></a>
                <a href="mailto:info@medpervichka.ru">info@medpervichka.ru</a>
            </div>
            <div class="__menu">
                <div class="__row">
                    <!-- <div class="__col">
                        <button>Спикеры</button>
                        <button>Программа</button>
                        <button>Билеты</button>
                        <button>контакты</button>
                        <button>Спонсорам</button>
                    </div> -->
                    <div class="__col">
                        <button
                            @click.prevent="handleClickPersonal"
                        >Политика обработки и защиты персональных данных</button>
                        <button
                            @click.prevent="handleClickSoglashenie"
                        >Соглашение на обработку персональных данных</button>
                        <button
                            @click.prevent="handleClickOferta"
                        >Договор оферты</button>
                    </div>
                    <div class="__col __urinfo">
                        <p>ЮРИДИЧЕСКАЯ ИНФОРМАЦИЯ Организатор ИП Антропов Руслан Александрович ОГРНИП 322784700255063, ИНН 780521136219</p>
                    </div>
                </div>
            </div>
            <div class="">
                <img class="__logo" alt="Медпервичка" :src="logo">
                <div class="__copiright"></div>
            </div>
        </div>
    </div>
    <!-- <div class="footer"> -->
        <!-- <p>
            По вопросам сотрудничества обращаться в Телеграм <a :href="'https://t.me/'+telegram">@{{telegram}}</a> и <a :href="'mailto:'+email">{{ email }}</a>
        </p>
        <img class="logo" alt="Медпервичка" :src="logo"> -->
    <!-- </div> -->
    <PersonalBlock v-if="isOpenPersonal" @close-personal="handleClickPersonal"/>
    <SoglashenieBlock v-if="isOpenSoglashenie" @close-soglashenie="handleClickSoglashenie"/>
    <OfertaBlock v-if="isOpenOferta" @close-oferta="handleClickOferta"/>

</template>
<script>
import logo from '@/assets/logo.svg'
import contacts from '@/lib/contacts';
import tg from '@/assets/telegram.svg'
import wa from '@/assets/whatsapp.svg'
// import PopupBlock from './PopupBlock.vue';
import PersonalBlock from './PersonalBlock.vue';
import OfertaBlock from './OfertaBlock.vue';
import SoglashenieBlock from './SoglashenieBlock.vue';

export default {
    name: 'FooterBlock',
    components: {
        PersonalBlock,
        OfertaBlock,
        SoglashenieBlock
        // PopupBlock,
    },
    props: {},
    data() {
        return {
            logo: logo,
            contacts: contacts,
            tg,
            wa,
            isOpenPersonal: false,
            isOpenSoglashenie: false,
            isOpenOferta: false,
            // showOferta: false,
            // showPolitica: false,
            // email: 'info@medpervichka.ru',
            // telegram: 'Ruslan_Amigorus',
        }
    },
    mounted() {
    },
    methods: {
        handleClickButton: function(href) {
            window.location = href
        },

        // handleClickButtonOferta: function() {
        //     this.showOferta = true
        // },
        // handleClickButtonPolitica: function() {
        //     this.showPolitica = true
        // },
        handleClickPersonal: function() {
            this.isOpenPersonal = !this.isOpenPersonal
        },
        handleClickSoglashenie: function() {
            this.isOpenSoglashenie = !this.isOpenSoglashenie
        },
        handleClickOferta: function() {
            this.isOpenOferta = !this.isOpenOferta
        },
    }
}
</script>
<style lang="scss">
$primary: #1E9BD8;
$secondary: #45289C;
.footer{
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 570px;
    .__top{
        background-color: rgba(34, 0, 224, 0);
        height: 200px;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
    }
    .__bottom{
        // background-color: rgb(51, 0, 154);
        height: 400px;
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        background-image: linear-gradient( 45deg,#290A4F,#350098 );
        z-index: 0;

    }
    .__info{
        display: flex;
        flex-direction: column;
        // background-image: radial-gradient( circle at 0% 5%, $primary 10%, transparent ), radial-gradient( circle at 100% 5%, $secondary 10%, transparent );
        background-image: radial-gradient(circle at -81% 175%, #1E9BD8 0%, transparent 60%), radial-gradient(circle at 152% 33%, #113194 34%, transparent 60%);
        // .card{
        // }
        .__title{
            font-weight: 600;
            color: #fff;
            font-size: 2em;
            text-align: left;
            padding-left: 16px;
            padding-top: 16px;
        }
        .__content{
            display: flex;
            flex-direction: row;
            @media ( max-width: 992px ) {
                flex-direction: column;
            }
        }
        position: relative;
        z-index: 10;
        display: flex;
        background-color: $secondary;
        border-radius: 25px;
        padding: 1em;
        .form{
            background-color: transparent;
        }
        .__form,.__contacts{
            padding: 1em;
            .__notes{
                text-transform: uppercase;
                color: $primary;
                text-align: left;
                margin-bottom: 1.25em;
            }
        }
        .__buttons{
            // padding: .5em 0;
            text-align: left;
            button{
                border: solid 1px $primary;
                background: transparent;
                border-radius: 15px;
                color: #fff;
                padding: .5em .85em;
                margin-right: .5em;
                line-height: 0;
                height: 34px;
            }
            margin-bottom: 2em;
        }
        .__links{
            display: flex;
            flex-direction: column;
            // justify-content: flex-start;
            text-align: left;
            // padding: .5em 0;
            a{
                color: #fff;
                margin-bottom: 2em;
                transition: .4s;
                &:hover{
                    color: #37bcff;
                    transition: .4s;
                    &>div{
                        img{
                            box-shadow: 0px 0px 4px 0px #fff;
                            transition: .4s;
                        }
                    }
                }
                // padding: .5em .85em;
                // margin-right: .5em;
                &>div{
                    display: flex;
                    align-items: center;
                    img{
                        transition: .4s;
                        margin-right: 4px;
                        border-radius: 50px;
                        width: 40px;
                        height: 40px;
                    }
                }
            }
        }
    }

    .__end{
        padding-top: 50px;
        padding-bottom: 25px;
        display: flex;
        flex-direction: column;
        position: relative;
        .__menu{
            margin: 25px 0 25px 0;
            color: #fff;
            button{
                border: none;
                background: none;
                color: #fff;
                cursor: pointer;
                transition: .4s;
                &:hover{
                    transition: .4s;
                    color: #1E9BD8;
                }
            }
        }
        .__logo{
            position: relative;
            z-index: 10;
            // min-height: 200px;
            // width: 100%;
            height: 50px;
        }
        .__copyright{
            min-height: 50px;
        }
        .__row{
            display: flex;
            flex-wrap: wrap;
            .__col{
                flex-basis: 100%;
                margin-bottom: 25px;
            }
        }
        .__contacts{
            color: #1E9BD8;
            // font-size: 1.25em;
            display: inline-flex;
            justify-content: center;
            flex-wrap: wrap;
            align-items: center;
            @media ( max-width: 768px) {
                display: flex;
                flex-direction: column;
            }
            // &>div{
            //     display: flex;
            //     flex-direction: row;
            //     align-items: center;
            //     justify-content: center;
            // }
            a{
                color: #1E9BD8;
                // border: solid 1px #56c7ff;
                padding: 5px 15px;
                margin: 10px;
                border-radius: 25px;
                text-decoration: none;
                line-height: 1;
                transition: .4s;
                &:hover{
                    color: #fff;
                    transition: .4s;
                    &>div{
                        img{
                            box-shadow: 0px 0px 4px 0px #fff;
                            // border-radius: 50px;
                            transition: .4s;
                        }
                    }
                }
                &>div{
                    display: flex;
                    align-items: center;
                    img{
                        margin-right: 4px;
                        width: 40px;
                        height: 40px;
                        border-radius: 50px;
                        transition: .4s;
                    }
                }
            }
        }
        // button{
        //     border-bottom: solid 1px #fff;
        // }
    }
    .__urinfo{
        font-size: .6em;
        color: #a3a3a3;
    }
    // background-color: #243255bd;
    // color: #fff;
    // p{
    //     padding-top: 1em;
    // }
    // a{
    //     color: #fff;
    // }
    // img{
    //     max-height: 46px;
    // }
}
</style>